export default __webpack_public_path__ + "static/media/live-curveSlider.1bee2c2e.png";